module.exports = __webpack_public_path__ + "static/media/Group 981.c0e356d0.svg";